module.exports = __webpack_public_path__ + "img/logo_doge.cf7491ea.png";